import {Toggle} from "@fluentui/react";
import React from "react";

interface IDisableEnableButtonProps {
    id: string;
    disabled :boolean;
    onEnable: (companyId: string) => void;
    onDisable: (companyId: string) => void;
}

const DisableEnableButton :React.FC<IDisableEnableButtonProps> = (props) => {
    const [ disabled, setDisabled ] = React.useState<boolean>(props.disabled);
    
    React.useEffect(() => {
        setDisabled(props.disabled);
    }, [props.disabled]);
    
    const toggleCompany = async (id: string) => {
        if(id !== undefined) {
            if (disabled) {
                props.onEnable(id);
                setDisabled(false);
            } else {
                props.onDisable(id);
                setDisabled(true);
            }
        }
    }
    
    return (
        <Toggle
            checked={!disabled}
            onChange={() => toggleCompany(props.id)}
        />
    );
}
export default DisableEnableButton;